export default __webpack_public_path__ + "static/media/BOB_0247.663306e3.JPG";